(() => {
  const isCollectionLikePage = () => {
    try {
      const path = String((window.location && window.location.pathname) || '').toLowerCase();
      const body = document.body;
      const bodyClass = String((body && body.className) || '').toLowerCase();
      return path.indexOf('/collections/') === 0 || path.indexOf('/search') === 0 || bodyClass.indexOf('template-collection') > -1 || bodyClass.indexOf('template-search') > -1;
    } catch (_) {
      return false;
    }
  };

  if (window.__esSwatchEnhanceBooted) {
    try {
      if (typeof window.__esPrimeSelectedSwatchCache === 'function') window.__esPrimeSelectedSwatchCache();
      if (typeof window.__esInitCardSwatchGroups === 'function') window.__esInitCardSwatchGroups(document);
      if (typeof window.__esInitSwatchScrollHints === 'function') window.__esInitSwatchScrollHints();
      if (!isCollectionLikePage() && typeof window.__esResetStaleCardImageOpacity === 'function') window.__esResetStaleCardImageOpacity();
    } catch (_) {}
    return;
  }
  window.__esSwatchEnhanceBooted = true;
  // Capture swatch clicks BEFORE legacy jQuery handlers.
  // After selecting a color swatch, hover swap (desktop) + swipe (mobile)
  // should show the 2nd image for the CURRENT selected color (ES-like).

  // ES 1650: product-card color selectors are native buttons. One active/first
  // swatch stays in the Tab order; arrow keys move and commit within the group.
  const ES_SWATCH_CONTROL_SELECTOR = '[data-es-swatch-control]';
  const ES_ACTIVE_SWATCH_SELECTOR = '.engoj_select_color [data-es-swatch-control].active';

  const getCardSwatches = (wrap) => {
    if (!wrap || !wrap.querySelectorAll) return [];
    return Array.from(wrap.querySelectorAll(ES_SWATCH_CONTROL_SELECTOR)).filter((el) =>
      el && !el.disabled && el.getAttribute('aria-disabled') !== 'true' && !el.hidden
    );
  };

  const syncCardSwatchTabStops = (wrap, preferred) => {
    const swatches = getCardSwatches(wrap);
    if (!swatches.length) return [];
    const active = swatches.find((el) => el.classList && el.classList.contains('active'));
    const target = (preferred && swatches.includes(preferred)) ? preferred : (active || swatches[0]);
    swatches.forEach((el) => el.setAttribute('tabindex', el === target ? '0' : '-1'));
    return swatches;
  };

  const initCardSwatchGroups = (root) => {
    const scope = root && root.querySelectorAll ? root : document;
    const groups = [];
    if (scope.matches && scope.matches('.engoj_select_color')) groups.push(scope);
    scope.querySelectorAll('.engoj_select_color').forEach((wrap) => groups.push(wrap));
    groups.forEach((wrap) => {
      if (!wrap.querySelector(ES_SWATCH_CONTROL_SELECTOR)) return;
      syncCardSwatchTabStops(wrap);
      if (!wrap.getAttribute('aria-label')) wrap.setAttribute('aria-label', 'Choose color');
      if (!wrap.getAttribute('role')) wrap.setAttribute('role', 'group');
    });
  };
  window.__esInitCardSwatchGroups = initCardSwatchGroups;

  const norm = (u) => String(u || '')
    .replace(/^https?:/,'')
    .split('?')[0]
    .trim();

  
  const upgradeUrl = (url, targetWidth = 1200) => {
    let u = String(url || '');
    if (!u) return u;

    // Prefer width query param if present
    u = u.replace(/([?&]width=)(\d+)/i, `$1${targetWidth}`);

    // Shopify size suffixes can look like: _360x.jpg, _360x360.jpg, _grande.jpg, _master.jpg
    // We normalize all of those to a higher-res _{targetWidth}x before the file extension.
    u = u
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|1024x1024|2048x2048|master)(?=\.(?:jpg|jpeg|png|webp|gif))/i, `_${targetWidth}x`)
      .replace(/_(\d+)(x(\d+))?x?(?=\.(?:jpg|jpeg|png|webp|gif))/i, `_${targetWidth}x`);

    return u;
  };
const getRenderedTargetWidth = (img, maxWidth = 1200) => {
    try {
      let rect = img && img.getBoundingClientRect ? img.getBoundingClientRect() : null;
      let cssWidth = Math.max(0, Number((rect && rect.width) || (img && img.clientWidth) || 0));

      // A newly created alternate swipe slide is hidden until its URL is ready, so its own
      // measured width is zero. Reuse the visible primary image as the sizing reference rather
      // than falling back to an unnecessarily large card image.
      if (cssWidth <= 0 && img && img.closest) {
        const card = img.closest('.engoj_grid_parent, [data-es-product-card], .product');
        const references = card && card.querySelectorAll
          ? card.querySelectorAll('img.es-swipe-img, img.engo-primary-image')
          : [];
        for (let i = 0; i < references.length; i++) {
          const reference = references[i];
          if (!reference || reference === img) continue;
          rect = reference.getBoundingClientRect ? reference.getBoundingClientRect() : null;
          const referenceWidth = Math.max(0, Number((rect && rect.width) || reference.clientWidth || 0));
          if (referenceWidth > 0) {
            cssWidth = referenceWidth;
            break;
          }
        }
      }

      const dpr = Math.max(1, Math.min(2.25, Number(window.devicePixelRatio || 1)));
      const wanted = cssWidth > 0 ? Math.ceil(cssWidth * dpr) : 720;
      const steps = [360, 540, 720, 900, 1080, 1200];
      for (let i = 0; i < steps.length; i++) {
        if (wanted <= steps[i]) return Math.min(steps[i], maxWidth);
      }
    } catch (_) {}
    return maxWidth;
  };

  const resolveImageUrl = (img, url, maxWidth = 1200) =>
    upgradeUrl(url, getRenderedTargetWidth(img, maxWidth));

  const getImageList = (card) => {
    const listStr = (card && card.dataset && card.dataset.esImagelist) ? card.dataset.esImagelist : '';
    if (!listStr) return [];
    return listStr.split('||').map((s) => String(s).trim()).filter(Boolean);
  };

  const pickAlt = (card, img1, img2) => {
    if (img2) return img2;
    if (card && card.getAttribute && card.getAttribute('data-es-color-media-safe') === '1') return '';
    const list = getImageList(card);
    if (!list.length || !img1) return '';

    const n1 = norm(img1);
    let idx = -1;
    for (let i = 0; i < list.length; i++) {
      if (norm(list[i]) === n1) {
        idx = i;
        break;
      }
    }

    // Preferred: next image after img1
    if (idx > -1 && idx + 1 < list.length) return list[idx + 1];

    // Fallback: first different image in list
    for (let j = 0; j < list.length; j++) {
      if (norm(list[j]) !== n1) return list[j];
    }
    return '';
  };

  const setImg = (img, url, maxWidth = 1200, requestToken) => {
    if (!img || !url) return '';
    if (requestToken != null && img.__esImageWriteToken !== requestToken) return '';
    if (requestToken == null) {
      img.__esImageWriteToken = (img.__esImageWriteToken || 0) + 1;
      img.classList.remove('es-image-fading', 'es-qv-fading');
    }
    const resolved = resolveImageUrl(img, url, maxWidth);
    try {
      // A preview has no committed variant media ID. Do not leave the old ID
      // attached to a different asset and fool the PDP same-media fast path.
      if (norm(img.getAttribute('src') || '') !== norm(resolved)) img.removeAttribute('data-es-media-id');
      img.setAttribute('src', resolved);
      img.setAttribute('data-src', resolved);

      // A color change invalidates the old color's responsive candidates. Replace them
      // with one correctly sized CDN URL instead of forcing 1200px on every card.
      ['srcset','data-srcset','sizes','data-sizes'].forEach((a) => {
        try { img.removeAttribute(a); } catch(_) {}
      });

      if (img.classList) {
        img.classList.remove('lazyload', 'lazyloading');
        img.classList.add('lazyloaded');
      }
      if (img.style) {
        img.style.filter = 'none';
        img.style.opacity = '1';
      }
    } catch(e) {}
    return resolved;
  };

  const fadeSwapImg = (img, url, maxWidth = 1200, onApply) => {
    if (!img || !url) return;
    const u = resolveImageUrl(img, url, maxWidth);
    const token = (img.__esImageWriteToken || 0) + 1;
    img.__esImageWriteToken = token;
    img.classList.remove('es-image-fading', 'es-qv-fading');
    img.removeAttribute('data-es-image-load-failed');
    const currentSrc = norm(img.getAttribute('src') || img.currentSrc || '');
    if (currentSrc && currentSrc === norm(u)) {
      try {
        img.classList.remove('es-image-fading');
        img.style.opacity = '1';
        img.style.filter = 'none';
      } catch(e) {}
      if (typeof onApply === 'function') onApply(u);
      return;
    }

    try {
      if (!img.dataset.esFadeSwapReady) {
        img.style.transition = img.style.transition || 'opacity .16s ease';
        img.dataset.esFadeSwapReady = '1';
      }
    } catch(e) {}

    preloadThen(u, (_url, loaded) => {
      if (!img || img.__esImageWriteToken !== token) return;
      const hero = img.matches && img.matches('[data-es-pdp-main-image],img.engoj_img_main,img.engoj_img_main_quickview');
      if (!loaded && hero) {
        img.setAttribute('data-es-image-load-failed', '1');
        return;
      }
      img.removeAttribute('data-es-image-load-failed');
      try { img.classList.add('es-image-fading'); } catch(_) {}
      setImg(img, u, maxWidth, token);
      if (typeof onApply === 'function') onApply(u);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!img || img.__esImageWriteToken !== token) return;
          try {
            img.classList.remove('es-image-fading');
            img.style.opacity = '1';
            img.style.filter = 'none';
          } catch(e) {}
        });
      });
    });
  };

  const ensureSecondary = (card) => {
    let secondary = card.querySelector('img.engo-secondary-image');
    if (secondary) return secondary;

    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const anchor = card.querySelector('a.engoj_find_img.engo-hover-swap') || card.querySelector('a.engoj_find_img');
    if (!primary || !anchor) return null;

    secondary = document.createElement('img');
    secondary.className = 'lazyload img-responsive engo-secondary-image';
    secondary.alt = '';
    secondary.setAttribute('aria-hidden', 'true');
    secondary.style.width = '100%';
    anchor.appendChild(secondary);
    return secondary;
  };

  const setSecondaryImage = (secondary, url, animate) => {
    if (!secondary) return;
    if (!url) {
      secondary.__esImageWriteToken = (secondary.__esImageWriteToken || 0) + 1;
      secondary.classList.remove('es-image-fading', 'es-qv-fading');
      secondary.hidden = true;
      secondary.setAttribute('aria-hidden', 'true');
      secondary.style.display = 'none';
      return;
    }
    secondary.hidden = false;
    secondary.removeAttribute('aria-hidden');
    secondary.style.removeProperty('display');
    if (animate) fadeSwapImg(secondary, url);
    else setImg(secondary, url);
  };

  const ensureSwipeSecondary = (swipe) => {
    let slide = swipe && swipe.querySelector ? swipe.querySelector('.es-swipe-slide:nth-child(2)') : null;
    if (slide) return slide;
    const firstSlide = swipe && swipe.querySelector ? swipe.querySelector('.es-swipe-slide') : null;
    const firstLink = firstSlide && firstSlide.querySelector ? firstSlide.querySelector('a.es-swipe-link') : null;
    const firstImg = firstSlide && firstSlide.querySelector ? firstSlide.querySelector('img.es-swipe-img') : null;
    if (!swipe || !firstLink || !firstImg) return null;

    slide = document.createElement('div');
    slide.className = 'es-swipe-slide';
    slide.hidden = true;
    slide.setAttribute('aria-hidden', 'true');

    const link = document.createElement('a');
    link.className = firstLink.className;
    link.href = firstLink.href;
    const productTitle = (firstImg.getAttribute('alt') || '').trim();
    link.setAttribute('aria-label', productTitle ? `View ${productTitle}, alternate image` : 'View alternate product image');

    const img = document.createElement('img');
    img.className = 'img-responsive es-swipe-img';
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.fetchPriority = 'low';
    link.appendChild(img);
    slide.appendChild(link);
    swipe.appendChild(slide);
    return slide;
  };

  const updateSwipe = (card, img1, img2, imageAlt) => {
    const swipe = card.querySelector('[data-es-swipe]');
    if (!swipe) return;
    if (img2) ensureSwipeSecondary(swipe);
    const imgs = swipe.querySelectorAll('img.es-swipe-img');
    const slides = swipe.querySelectorAll('.es-swipe-slide');
    if (imgs.length > 0 && img1) { setImg(imgs[0], img1, 1080); if (imageAlt != null) imgs[0].alt = imageAlt; }
    if (imgs.length > 1) {
      if (img2) {
        setImg(imgs[1], img2, 1080);
        if (slides[1]) {
          slides[1].hidden = false;
          slides[1].removeAttribute('aria-hidden');
        }
      } else if (slides[1]) {
        slides[1].hidden = true;
        slides[1].setAttribute('aria-hidden', 'true');
      }
    }
    if (card && card.classList) card.classList.toggle('es-swipe-enabled', !!img2);

    try { swipe.scrollLeft = 0; } catch(_) {}
    try { swipe.dispatchEvent(new Event('scroll')); } catch(_) {}
  };

  const updateIndicator = (card, enabled) => {
    const indicator = card.querySelector('.es-swipe-indicator');
    if (!indicator) return;
    if (enabled) indicator.classList.remove('is-hidden');
    else indicator.classList.add('is-hidden');
  };

  const getQuickviewHandleForCard = (card) => {
    try {
      const btn = card && card.querySelector ? card.querySelector('.engoj_btn_quickview[data-id]') : null;
      if (btn && btn.getAttribute('data-id')) return String(btn.getAttribute('data-id')).trim();
    } catch(e) {}
    try {
      const link = card && card.querySelector ? card.querySelector('.title-product a[href], .engoj_find_img[href]') : null;
      const href = link ? String(link.getAttribute('href') || '').trim() : '';
      const m = href.match(/\/products\/([^\/?#]+)/);
      if (m && m[1]) return decodeURIComponent(m[1]);
    } catch(e2) {}
    return '';
  };

  const persistQuickviewSelectionForHandle = (handle, payload) => {
    try {
      const key = String(handle || '').trim().toLowerCase();
      if (!key || !payload) return;
      const safe = {
        variantId: String(payload.variantId || '').trim(),
        image: String(payload.image || '').trim(),
        optionValue: String(payload.optionValue || '').trim(),
        updatedAt: Date.now()
      };
      window.__esQvPreferredSelectionByHandle = window.__esQvPreferredSelectionByHandle || {};
      window.__esQvPreferredSelectionByHandle[key] = safe;
      try { sessionStorage.setItem('es_qv_pref_' + key, JSON.stringify(safe)); } catch(eStore) {}
    } catch(e) {}
  };

  const buildVariantHref = (rawHref, variantId) => {
    const href = String(rawHref || '').trim();
    const vid = String(variantId || '').trim();
    if (!href || !vid || href === '#' || /^javascript:/i.test(href)) return href;
    try {
      const url = new URL(href, window.location.origin);
      url.searchParams.set('variant', vid);
      if (url.origin === window.location.origin) return url.pathname + url.search + url.hash;
      return url.href;
    } catch (_) {
      const hashParts = href.split('#');
      const baseAndQuery = hashParts.shift() || '';
      const hash = hashParts.length ? '#' + hashParts.join('#') : '';
      const parts = baseAndQuery.split('?');
      const base = parts.shift() || '';
      const params = new URLSearchParams(parts.join('?'));
      params.set('variant', vid);
      return base + '?' + params.toString() + hash;
    }
  };

  const updateCardVariantLinks = (card, control, variantId) => {
    if (!card || !variantId) return '';
    const explicit = control && control.getAttribute ? String(control.getAttribute('data-es-variant-url') || '').trim() : '';
    let selectedHref = explicit ? buildVariantHref(explicit, variantId) : '';
    const links = card.querySelectorAll('.engoj_find_img[href], .title-product a[href], .engoj_btn_quickview[href], .es-more-swatch[href]');
    links.forEach((link) => {
      if (!link || !link.getAttribute) return;
      let base = String(link.getAttribute('data-es-base-product-href') || '').trim();
      if (!base) {
        base = String(link.getAttribute('href') || '').trim();
        if (base && base !== '#' && !/^javascript:/i.test(base)) link.setAttribute('data-es-base-product-href', base);
      }
      const next = selectedHref || buildVariantHref(base, variantId);
      if (!next) return;
      link.setAttribute('href', next);
      if (link.classList && link.classList.contains('engoj_btn_quickview')) {
        link.setAttribute('data-es-qv-href', next);
        link.setAttribute('data-es-selected-variant-id', String(variantId));
      }
      if (!selectedHref) selectedHref = next;
    });
    if (selectedHref) card.setAttribute('data-es-selected-variant-url', selectedHref);
    return selectedHref;
  };

  const setActive = (a) => {
    const wrap = a.closest('.engoj_select_color');
    if (!wrap) return;

    // On click we are committing a real selection, so clear any hover-preview state first.
    // This prevents the brief split/tear effect where the preview underline and active
    // underline overlap for a frame.
    wrap.classList.add('is-committing');
    wrap.querySelectorAll('.border_thumbnail.is-preview').forEach((el) => el.classList.remove('is-preview'));
    wrap.querySelectorAll('[data-es-swatch-control].is-preview').forEach((el) => el.classList.remove('is-preview'));

    // Toggle active state on native swatch controls
    // and keep the accessibility pressed state synchronized with the visual state.
    getCardSwatches(wrap).forEach((el) => {
      el.classList.remove('active');
      el.setAttribute('aria-pressed', 'false');
    });
    a.classList.add('active');
    a.setAttribute('aria-pressed', 'true');
    syncCardSwatchTabStops(wrap, a);

    // Toggle active state on the wrapper <span class="border_thumbnail"> so our underline is reliable
    wrap.querySelectorAll('.border_thumbnail').forEach((el) => el.classList.remove('is-active'));
    const parentThumb = a.closest('.border_thumbnail');
    if (parentThumb) parentThumb.classList.add('is-active');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        wrap.classList.remove('is-committing');
      });
    });
  };

  const handleSwatchClick = (a) => {
    const card = a.closest('.engoj_grid_parent') || a.closest('.product') || a.closest('[data-es-imagelist]');
    if (!card) return;

    // Cancel any in-flight hover preview for this card before committing the real selection.
    clearHoverPreviewTimer(card, true);
    setCollectionSwatchPreviewState(card, false);

    setActive(a);

    // ES: Keep wishlist button bound to the selected variant (per-variant wishlist)
    try {
      const vid = a.getAttribute('data-es-variant-id') || (a.dataset && a.dataset.esVariantId) || '';
      if (vid) {
        card.setAttribute('data-es-selected-variant-id', vid);
        try { card.dataset.esSelectedVariantId = vid; } catch(eData) {}
        updateCardVariantLinks(card, a, vid);
        const btn = card.querySelector('button.es-wishlist-btn');
        if (btn) {
          btn.setAttribute('data-variant-id', vid);
          try { btn.dataset.variantId = vid; } catch(e) {}

          // ES FIX (2026-01-29): We do NOT re-initialize Swym on swatch changes.
          // Our wishlist click handler reads the current data-variant-id at click time.
          // So here we only re-apply visual state for the newly selected variant.
          if (window.esWishlistApplyToButton) window.esWishlistApplyToButton(btn);
        }
      }
    } catch(e) {}

    const img1 = a.getAttribute('data-engojvariant-img') || a.dataset.engojvariantImg || '';
    const img2raw = a.getAttribute('data-engojvariant-img2') || a.dataset.engojvariantImg2 || '';
    const img2 = pickAlt(card, img1, img2raw) || img2raw;

    const img1Large = upgradeUrl(img1, 1200);

    // Desktop images
    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const secondary = ensureSecondary(card);

    const imageAlt = a.getAttribute('data-es-image-alt') || card.getAttribute('data-es-default-alt') || '';
    if (primary && img1) fadeSwapImg(primary, img1, 1200, () => { primary.alt = imageAlt; });
    setSecondaryImage(secondary, img2, true);

    // Mobile swipe uses the same color-safe pair at a viewport-appropriate width.
    updateSwipe(card, img1, img2, imageAlt);
    const enabled = !!(img2 && norm(img2) !== norm(img1));
    updateIndicator(card, enabled);

    // Keep the nearest Quick View trigger aligned with the currently selected swatch.
    // This lets Quick View and then Lens Builder open on the same color/image the user picked.
    try {
      const qvBtn = card.querySelector('.engoj_btn_quickview');
      const vid = a.getAttribute('data-es-variant-id') || a.getAttribute('data-variant-id') || (a.dataset && (a.dataset.esVariantId || a.dataset.variantId)) || '';
      const optionValue = a.getAttribute('data-value') || a.getAttribute('data-color') || a.getAttribute('title') || a.getAttribute('aria-label') || '';
      if (qvBtn) {
        if (vid) {
          qvBtn.setAttribute('data-es-selected-variant-id', vid);
          try { qvBtn.dataset.esSelectedVariantId = vid; } catch(_) {}
        }
        if (img1Large) {
          qvBtn.setAttribute('data-es-selected-image', img1Large);
          try { qvBtn.dataset.esSelectedImage = img1Large; } catch(_) {}
        }
        if (optionValue) {
          qvBtn.setAttribute('data-es-selected-option-value', optionValue);
          try { qvBtn.dataset.esSelectedOptionValue = optionValue; } catch(_) {}
        }
      }
      const handle = getQuickviewHandleForCard(card);
      if (handle) {
        persistQuickviewSelectionForHandle(handle, { variantId: vid, image: img1Large, optionValue });
      }
    } catch(e) {}
  };


  const seedCardFromActiveSwatch = (card) => {
    const active = card.querySelector(ES_ACTIVE_SWATCH_SELECTOR) || card.querySelector('.engoj_select_color ' + ES_SWATCH_CONTROL_SELECTOR);
    if (!active) return;

    const vid = active.getAttribute('data-es-variant-id') || active.getAttribute('data-variant-id') || (active.dataset && (active.dataset.esVariantId || active.dataset.variantId)) || '';
    const img1 = active.getAttribute('data-engojvariant-img') || (active.dataset && active.dataset.engojvariantImg) || '';
    const img2raw = active.getAttribute('data-engojvariant-img2') || (active.dataset && active.dataset.engojvariantImg2) || '';
    const img2 = pickAlt(card, img1, img2raw) || img2raw;
    const img1Large = upgradeUrl(img1, 1200);
    const optionValue = active.getAttribute('data-value') || active.getAttribute('data-color') || active.getAttribute('title') || active.getAttribute('aria-label') || '';
    if (vid) updateCardVariantLinks(card, active, vid);

    // Keep visible card media crisp on first paint.
    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const secondary = ensureSecondary(card);
    const imageAlt = active.getAttribute('data-es-image-alt') || card.getAttribute('data-es-default-alt') || '';
    if (primary && img1) { setImg(primary, img1); primary.alt = imageAlt; }
    setSecondaryImage(secondary, img2, false);
    updateSwipe(card, img1, img2, imageAlt);
    updateIndicator(card, !!(img2 && norm(img2) !== norm(img1)));

    const qvBtn = card.querySelector('.engoj_btn_quickview');
    if (qvBtn) {
      if (vid) {
        qvBtn.setAttribute('data-es-selected-variant-id', vid);
        try { qvBtn.dataset.esSelectedVariantId = vid; } catch(_) {}
      }
      if (img1Large) {
        qvBtn.setAttribute('data-es-selected-image', img1Large);
        try { qvBtn.dataset.esSelectedImage = img1Large; } catch(_) {}
      }
      if (optionValue) {
        qvBtn.setAttribute('data-es-selected-option-value', optionValue);
        try { qvBtn.dataset.esSelectedOptionValue = optionValue; } catch(_) {}
      }
    }

    const handle = getQuickviewHandleForCard(card);
    if (handle) persistQuickviewSelectionForHandle(handle, { variantId: vid, image: img1Large, optionValue });
  };

  const queueIdleTask = (cb) => {
    if (typeof window.requestIdleCallback === 'function') {
      return window.requestIdleCallback(cb, { timeout: 180 });
    }
    return window.setTimeout(cb, 16);
  };

  const getCardDefaultImages = (card) => {
    if (!card) return { primary: '', secondary: '' };
    const primary = card.getAttribute('data-es-default-primary') || (card.dataset && card.dataset.esDefaultPrimary) || '';
    const secondary = card.getAttribute('data-es-default-secondary') || (card.dataset && card.dataset.esDefaultSecondary) || '';
    return { primary, secondary };
  };

  const restoreCardDefaultImages = (card) => {
    if (!card) return;
    const defaults = getCardDefaultImages(card);
    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const secondary = card.querySelector('img.engo-secondary-image');
    const imageAlt = card.getAttribute('data-es-default-alt') || '';
    if (primary && defaults.primary) fadeSwapImg(primary, defaults.primary, 1200, () => { primary.alt = imageAlt; });
    if (secondary) setSecondaryImage(secondary, defaults.secondary, true);
    updateSwipe(card, defaults.primary, defaults.secondary, imageAlt);
    updateIndicator(card, !!(defaults.secondary && norm(defaults.secondary) !== norm(defaults.primary)));

    try {
      const qvBtn = card.querySelector('.engoj_btn_quickview');
      if (qvBtn && defaults.primary) {
        qvBtn.setAttribute('data-es-selected-image', defaults.primary);
        if (qvBtn.dataset) qvBtn.dataset.esSelectedImage = defaults.primary;
      }
    } catch(_) {}
  };

  let seedGeneration = 0;
  window.addEventListener('pagehide', () => { seedGeneration += 1; });
  const seedQuickviewButtonsFromActiveSwatches = () => {
    const generation = ++seedGeneration;
    try {
      const cards = Array.from(document.querySelectorAll('.engoj_grid_parent, .product, [data-es-imagelist]'));
      if (!cards.length) return;

      const eagerCount = Math.min(cards.length, 12);
      for (let i = 0; i < eagerCount; i++) {
        seedCardFromActiveSwatch(cards[i]);
      }

      if (cards.length <= eagerCount) return;

      let cursor = eagerCount;
      const processChunk = () => {
        if (generation !== seedGeneration) return;
        const end = Math.min(cursor + 18, cards.length);
        for (; cursor < end; cursor++) {
          seedCardFromActiveSwatch(cards[cursor]);
        }
        if (cursor < cards.length) queueIdleTask(processChunk);
      };

      queueIdleTask(processChunk);
    } catch(e) {}
  };


  const shouldSeedCollectionCardsOnFirstLoad = !isCollectionLikePage();

  if (document.readyState === 'loading') {
    if (shouldSeedCollectionCardsOnFirstLoad) {
      document.addEventListener('DOMContentLoaded', seedQuickviewButtonsFromActiveSwatches, { once: true });

    }
  } else {
    if (shouldSeedCollectionCardsOnFirstLoad) seedQuickviewButtonsFromActiveSwatches();
  }

  // Initial pageshow follows DOMContentLoaded and does not need another sweep.
  // A BFCache restoration does: preserve the selected color/Quick View state.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted && shouldSeedCollectionCardsOnFirstLoad) {
      setTimeout(seedQuickviewButtonsFromActiveSwatches, 90);
    }
  });

  const resetStaleCardImageOpacity = () => {
    try {
      document.querySelectorAll('.product-item-v1 img.engo-primary-image, .product-item-v1 img.engo-secondary-image, .product-item-v1 img.es-swipe-img').forEach((img) => {
        const current = parseFloat((img.style && img.style.opacity) || '1');
        if (!Number.isNaN(current) && current < 0.98) {
          img.style.opacity = '1';
          img.style.filter = 'none';
        }
      });
    } catch(_) {}
  };
  window.__esResetStaleCardImageOpacity = resetStaleCardImageOpacity;

  if (document.readyState === 'loading') {
    if (!isCollectionLikePage()) {
      document.addEventListener('DOMContentLoaded', () => setTimeout(resetStaleCardImageOpacity, 320), { once: true });
    }
    window.addEventListener('pageshow', () => setTimeout(resetStaleCardImageOpacity, 120));
  } else {
    if (!isCollectionLikePage()) setTimeout(resetStaleCardImageOpacity, 320);
  }


  // Native buttons already support Enter/Space. Arrow keys provide compact roving
  // navigation so every product card does not add four separate Tab stops.
  document.addEventListener('keydown', (e) => {
    const swatch = e.target && e.target.closest ? e.target.closest(ES_SWATCH_CONTROL_SELECTOR) : null;
    if (!swatch) return;
    const key = e.key;
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(key)) return;
    const wrap = swatch.closest('.engoj_select_color');
    const swatches = getCardSwatches(wrap);
    if (swatches.length < 2) return;
    const current = Math.max(0, swatches.indexOf(swatch));
    const rtl = wrap && window.getComputedStyle ? window.getComputedStyle(wrap).direction === 'rtl' : false;
    let next = current;
    if (key === 'Home') next = 0;
    else if (key === 'End') next = swatches.length - 1;
    else {
      const forward = key === 'ArrowRight' || key === 'ArrowDown';
      const logicalForward = (key === 'ArrowLeft' || key === 'ArrowRight') && rtl ? !forward : forward;
      next = (current + (logicalForward ? 1 : -1) + swatches.length) % swatches.length;
    }
    e.preventDefault();
    swatches[next].focus({ preventScroll: true });
    swatches[next].click();
  }, true);

  const hydrateCardSwatches = (root) => initCardSwatchGroups(root || document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => hydrateCardSwatches(document), { once: true });
  } else {
    hydrateCardSwatches(document);
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) hydrateCardSwatches(document);
  });
  document.addEventListener('es:collection:updated', (e) => {
    const root = e && e.detail && (e.detail.container || e.detail.root);
    hydrateCardSwatches(root || document);
  });

  // Use capture phase so we run before any legacy jQuery click handlers.
  document.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest(ES_SWATCH_CONTROL_SELECTOR) : null;
    if (!a) return;

    handleSwatchClick(a);

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
  }, true);

  /* =========================================================
     Hover preview (temporary) — desktop only
     - Hover is NOT a selection; click still selects.
     - Adds animated gold line + swaps the main image for fast browsing.
     ========================================================= */

  const canHoverPreview = (() => {
    try {
      return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    } catch (e) {
      return false;
    }
  })();


  const ES_HOVER_PREVIEW_DELAY = 70;
  const ES_COLLECTION_HOVER_PREVIEW_DELAY = 35;
  const ES_PDP_HOVER_PREVIEW_DELAY = 0;
  const ES_QUICKVIEW_HOVER_PREVIEW_DELAY = 10;
  const ES_COLLECTION_RESTORE_GRACE = 90;
  const ES_PDP_RESTORE_GRACE = 120;
  const ES_QUICKVIEW_RESTORE_GRACE = 120;
  const __esHoverPreviewTimers = window.__esHoverPreviewTimers || (window.__esHoverPreviewTimers = new WeakMap());
  const __esHoverPreviewVersions = window.__esHoverPreviewVersions || (window.__esHoverPreviewVersions = new WeakMap());
  const __esHoverRestoreTimers = window.__esHoverRestoreTimers || (window.__esHoverRestoreTimers = new WeakMap());
  const __esActivePdpPreviewStrips = window.__esActivePdpPreviewStrips || (window.__esActivePdpPreviewStrips = new Set());

  const getHoverPreviewVersion = (key) => {
    if (!key) return 0;
    return Number(__esHoverPreviewVersions.get(key) || 0);
  };

  const bumpHoverPreviewVersion = (key) => {
    if (!key) return 0;
    const next = getHoverPreviewVersion(key) + 1;
    __esHoverPreviewVersions.set(key, next);
    return next;
  };

  const clearHoverPreviewTimer = (key, invalidate = false) => {
    if (!key) return;
    const existing = __esHoverPreviewTimers.get(key);
    if (existing) {
      try { window.clearTimeout(existing); } catch (_) {}
      __esHoverPreviewTimers.delete(key);
    }
    if (invalidate) bumpHoverPreviewVersion(key);
  };

  const scheduleHoverPreview = (key, fn, delay = ES_HOVER_PREVIEW_DELAY) => {
    if (!key || typeof fn !== 'function') return;
    clearHoverPreviewTimer(key);
    const version = bumpHoverPreviewVersion(key);
    const timer = window.setTimeout(() => {
      __esHoverPreviewTimers.delete(key);
      fn(version);
    }, delay);
    __esHoverPreviewTimers.set(key, timer);
    return version;
  };

  const clearHoverRestoreTimer = (key) => {
    if (!key) return;
    const existing = __esHoverRestoreTimers.get(key);
    if (existing) {
      try { window.clearTimeout(existing); } catch (_) {}
      __esHoverRestoreTimers.delete(key);
    }
  };

  const scheduleHoverRestore = (key, fn, delay) => {
    if (!key || typeof fn !== 'function') return;
    clearHoverRestoreTimer(key);
    const timer = window.setTimeout(() => {
      __esHoverRestoreTimers.delete(key);
      fn();
    }, Math.max(0, Number(delay || 0)));
    __esHoverRestoreTimers.set(key, timer);
    return timer;
  };

  const isHoverPreviewCurrent = (key, version) => {
    if (!key) return false;
    return getHoverPreviewVersion(key) === Number(version || 0);
  };

  const extractBgUrl = (el) => {
    if (!el) return '';
    const bg = (el.style && el.style.backgroundImage) ? el.style.backgroundImage : '';
    if (!bg) return '';
    const m = bg.match(/url\((['"]?)(.*?)\1\)/i);
    return m ? m[2] : '';
  };

  const __esPreloadedImageCache = window.__esPreloadedImageCache || (window.__esPreloadedImageCache = {});
  const ES_PRELOAD_CACHE_LIMIT = 80;
  const rememberPreloadedImage = (key) => {
    // Refresh insertion order for LRU eviction; never evict in-flight promises.
    delete __esPreloadedImageCache[key];
    __esPreloadedImageCache[key] = true;
    const completed = Object.keys(__esPreloadedImageCache).filter((url) => __esPreloadedImageCache[url] === true);
    completed.slice(0, Math.max(0, completed.length - ES_PRELOAD_CACHE_LIMIT)).forEach((url) => {
      delete __esPreloadedImageCache[url];
    });
  };
  const preloadThen = (url, cb) => {
    if (!url || typeof cb !== 'function') return;
    const key = String(url || '');
    const notify = (loaded) => { try { cb(key, loaded); } catch (_) {} };
    const cached = __esPreloadedImageCache[key];
    if (cached === true) {
      rememberPreloadedImage(key);
      notify(true);
      return;
    }
    if (cached && typeof cached.then === 'function') {
      cached.then((loaded) => notify(loaded), () => notify(false));
      return;
    }
    let resolvePromise;
    const prom = new Promise((resolve) => { resolvePromise = resolve; });
    __esPreloadedImageCache[key] = prom;
    const img = new Image();
    let settled = false;
    let decoding = false;
    let timeoutId = 0;
    const finish = (loaded) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeoutId);
      img.onload = null;
      img.onerror = null;
      if (__esPreloadedImageCache[key] === prom) {
        if (loaded) rememberPreloadedImage(key);
        else delete __esPreloadedImageCache[key];
      }
      // Pass readiness to hero writers; card-image fallbacks stay available.
      resolvePromise(loaded);
    };
    img.onload = () => {
      if (settled || decoding) return;
      decoding = true;
      if (typeof img.decode !== 'function') { finish(true); return; }
      try { Promise.resolve(img.decode()).then(() => finish(true), () => finish(false)); }
      catch (_) { finish(false); }
    };
    img.onerror = () => finish(false);
    timeoutId = window.setTimeout(() => finish(false), 8000);
    img.decoding = 'async';
    img.src = key;
    prom.then((loaded) => notify(loaded), () => notify(false));
  };

  const findCard = (el) => {
    return el.closest('.engoj_grid_parent') || el.closest('.product') || el.closest('[data-es-imagelist]');
  };

  const applyImagesFromAnchor = (card, a) => {
    if (!card || !a) return;
    const img1 = a.getAttribute('data-engojvariant-img') || a.dataset.engojvariantImg || '';
    const img2raw = a.getAttribute('data-engojvariant-img2') || a.dataset.engojvariantImg2 || '';
    const img2 = pickAlt(card, img1, img2raw) || img2raw;
    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    const secondary = ensureSecondary(card);

    const imageAlt = a.getAttribute('data-es-image-alt') || card.getAttribute('data-es-default-alt') || '';
    if (primary && img1) fadeSwapImg(primary, img1, 1200, () => { primary.alt = imageAlt; });
    if (secondary && img2) fadeSwapImg(secondary, img2);

    updateSwipe(card, img1, img2, imageAlt);
    const enabled = !!(img2 && norm(img2) !== norm(img1));
    updateIndicator(card, enabled);
  };

  const restoreCardImages = (card) => {
    if (!card) return;
    const active = card.querySelector(ES_ACTIVE_SWATCH_SELECTOR);
    if (active) {
      applyImagesFromAnchor(card, active);
      return;
    }
    restoreCardDefaultImages(card);
  };

  const setCollectionSwatchPreviewState = (card, enabled) => {
    if (!card || !card.classList) return;
    card.classList.toggle('es-collection-swatch-preview-active', !!enabled);
    if (enabled) {
      try {
        card.querySelectorAll('.is-deliberate-hover').forEach((el) => el.classList.remove('is-deliberate-hover'));
      } catch (_) {}
    }
  };

  const applyCollectionPreviewFromAnchor = (card, a) => {
    if (!card || !a) return;
    const img1 = a.getAttribute('data-engojvariant-img') || a.dataset.engojvariantImg || '';
    if (!img1) return;

    setCollectionSwatchPreviewState(card, true);

    const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
    if (primary) fadeSwapImg(primary, img1, 1200, () => { primary.alt = a.getAttribute('data-es-image-alt') || card.getAttribute('data-es-default-alt') || ''; });
  };

  const resolveMainPreviewUrl = (scope, url) => {
    // Match setMainImgs' target and sizing policy. A fixed 1200px preload would
    // otherwise be followed by another request for the rendered hero size.
    const qv = scope && scope.closest ? scope.closest('.quickview-product') : null;
    const root = qv || document.querySelector('body.template-product .content-page-detail') || document.querySelector('body.template-product');
    if (!root) return upgradeUrl(url, 1200);
    const targets = root.querySelectorAll(qv ? 'img.engoj_img_main_quickview' : '[data-es-pdp-main-image], img.engoj_img_main');
    let fallback = null;
    for (const img of targets) {
      if (!fallback) fallback = img;
      const rect = img.getBoundingClientRect ? img.getBoundingClientRect() : null;
      if (Number((rect && rect.width) || img.clientWidth || 0) > 0) return resolveImageUrl(img, url, 1200);
    }
    return fallback ? resolveImageUrl(fallback, url, 1200) : upgradeUrl(url, 1200);
  };

  const setMainImgs = (scope, url) => {
    if (!scope || !url) return;
    const u = upgradeUrl(url, 1200);

    // Quickview uses a dedicated class
    const qv = scope.closest('.quickview-product');
    if (qv) {
      const main = qv.querySelector('img.engoj_img_main_quickview');
      if (main) fadeSwapImg(main, u);

      // Keep Quickview "hover next image" in sync with the temporarily previewed image
      try {
        if (window.jQuery && window.tshopifyQuickview && typeof window.tshopifyQuickview.updateQuickviewHoverSwap === 'function') {
          const $qv = window.jQuery(qv);
          const p = $qv.data('esQvProduct');
          if (p) setTimeout(() => window.tshopifyQuickview.updateQuickviewHoverSwap(p, $qv), 120);
        }
      } catch(_) {}

      return;
    }

    // PDP: keep the visible hero image and its lightbox target in one synchronized state.
    const pdpRoot = document.querySelector('body.template-product .content-page-detail') || document.querySelector('body.template-product');
    if (pdpRoot) {
      pdpRoot.querySelectorAll('[data-es-pdp-main-image], img.engoj_img_main').forEach((img) => {
        fadeSwapImg(img, u, 1200, function(){
          const source = Array.from(pdpRoot.querySelectorAll('[data-es-source-url]')).find(a => norm(a.getAttribute('data-es-source-url')) === norm(url));
          if (source) img.alt = source.getAttribute('data-es-image-alt') || '';
          const largeUrl = upgradeUrl(url, 2400);
          pdpRoot.querySelectorAll('[data-es-pdp-main-link], .product-img-box .img-product a.fancybox').forEach(function(a){
            if (a && a.setAttribute) {
              a.setAttribute('href', largeUrl);
              a.removeAttribute('data-es-media-id');
            }
          });
        });
      });
    }

    // Sync PDP "hover next image" with the previewed image
    try {
      if (window.ES_PDP_HoverSwap && typeof window.ES_PDP_HoverSwap.update === 'function') {
        setTimeout(() => window.ES_PDP_HoverSwap.update(), 120);
      }
    } catch(_) {}
  };

  // ---------------------------------------------------------
// ES: Remember the "real selected" swatch image per strip
// so hover-preview can always restore correctly on mouseleave.
// ---------------------------------------------------------
const getSelectedUrlFromStrip = (strip) => {
  if (!strip) return '';
  // 1) remembered (most reliable)
  const remembered = strip.dataset.esSelectedUrl || strip.getAttribute('data-es-selected-url') || '';
  if (remembered) return remembered;

  // 2) checked radio
  let checked = null;
  try { checked = strip.querySelector('input[type="radio"]:checked'); } catch(_) {}
  if (checked) {
    const wrap = checked.closest('.maxus-color');
    const label = wrap && wrap.querySelector('label.color_style2');
    const url = extractBgUrl(label);
    if (url) return upgradeUrl(url, 1200);
  }

  // 3) active class fallbacks (some theme states don't keep radio.checked in sync)
  const active = strip.querySelector('.maxus-color.is-active, .maxus-color.active, .maxus-color.selected');
  if (active) {
    const label = active.querySelector('label.color_style2');
    const url = extractBgUrl(label);
    if (url) return upgradeUrl(url, 1200);
  }

  return '';
};

const rememberSelectedUrl = (strip, url) => {
  if (!strip || !url) return;
  strip.dataset.esSelectedUrl = url;
  try { strip.setAttribute('data-es-selected-url', url); } catch(_) {}
};

const rememberSelectedFromDom = (strip) => {
  const url = getSelectedUrlFromStrip(strip);
  if (url) rememberSelectedUrl(strip, url);
};

const restoreMainImgsFromSelected = (strip) => {
  if (!strip) return;
  const url = strip.dataset.esSelectedUrl || getSelectedUrlFromStrip(strip);
  if (!url) return;
  setMainImgs(strip, url);
};

const markPdpPreviewActive = (strip) => {
  if (!strip) return;
  __esActivePdpPreviewStrips.add(strip);
  try { strip.dataset.esPreviewActive = '1'; } catch(_) {}
};

const clearPdpPreviewActive = (strip) => {
  if (!strip) return;
  __esActivePdpPreviewStrips.delete(strip);
  try { delete strip.dataset.esPreviewActive; } catch(_) {}
};

const getPdpSwatchHotItemAtPoint = (strip, clientX, clientY) => {
  if (!strip || typeof clientX !== 'number' || typeof clientY !== 'number') return null;
  const items = strip.querySelectorAll('.maxus-color');
  const pad = 1;
  for (const item of items) {
    const box = item.querySelector('.radio_style2') || item;
    if (!box || typeof box.getBoundingClientRect !== 'function') continue;
    const r = box.getBoundingClientRect();
    if (clientX >= r.left - pad && clientX <= r.right + pad && clientY >= r.top - pad && clientY <= r.bottom + pad) {
      return item;
    }
  }
  return null;
};

const restorePdpStripFromHover = (strip) => {
  if (!strip) return;
  clearPdpPreviewActive(strip);
  try { strip.querySelectorAll('.maxus-color.is-preview').forEach((n) => n.classList.remove('is-preview')); } catch(_) {}
  clearHoverPreviewTimer(strip, true);
  restoreMainImgsFromSelected(strip);
};

const getStripHoverScope = (strip) => {
  if (!strip) return null;
  // Keep PDP/Quickview hover restore scoped to the actual swatch strip only.
  // Older logic used the whole .swatch / option row, which made the pointer look
  // like it was still inside the hover area while moving across blank row space.
  return strip;
};

const bindStripLeave = (strip) => {
  if (!strip || strip.dataset.esLeaveBound) return;
  strip.dataset.esLeaveBound = '1';

  const hoverScope = getStripHoverScope(strip) || strip;
  const restoreDelay = strip.closest('.quickview-product') ? ES_QUICKVIEW_RESTORE_GRACE : ES_PDP_RESTORE_GRACE;

  if (hoverScope && !hoverScope.dataset.esHoverScopeBound) {
    hoverScope.dataset.esHoverScopeBound = '1';

    hoverScope.addEventListener('mouseenter', () => {
      clearHoverRestoreTimer(hoverScope);
    }, true);

    hoverScope.addEventListener('mouseleave', () => {
      scheduleHoverRestore(hoverScope, () => {
        try {
          if (hoverScope.matches && hoverScope.matches(':hover')) return;
        } catch(_) {}
        restorePdpStripFromHover(strip);
      }, restoreDelay);
    }, true);
  }
};


const getCollectionHoverScope = (wrap) => {
  if (!wrap) return null;
  return wrap.closest('.image-thumbnail')
    || wrap.parentElement
    || wrap;
};

const bindCollectionWrapLeave = (wrap) => {
  if (!wrap || wrap.dataset.esWrapLeaveBound) return;
  wrap.dataset.esWrapLeaveBound = '1';

  const hoverScope = getCollectionHoverScope(wrap) || wrap;

  if (hoverScope && !hoverScope.dataset.esWrapHoverScopeBound) {
    hoverScope.dataset.esWrapHoverScopeBound = '1';

    hoverScope.addEventListener('mouseenter', () => {
      clearHoverRestoreTimer(hoverScope);
    }, true);

    hoverScope.addEventListener('mouseleave', () => {
      scheduleHoverRestore(hoverScope, () => {
        try {
          if (hoverScope.matches && hoverScope.matches(':hover')) return;
        } catch(_) {}
        try {
          wrap.querySelectorAll('.border_thumbnail.is-preview').forEach((n) => n.classList.remove('is-preview'));
          wrap.querySelectorAll('[data-es-swatch-control].is-preview').forEach((n) => n.classList.remove('is-preview'));
        } catch(_) {}
        const card = findCard(wrap);
        clearHoverPreviewTimer(card, true);
        setCollectionSwatchPreviewState(card, false);
        restoreCardImages(card);
      }, ES_COLLECTION_RESTORE_GRACE);
    }, true);
  }
};

  // Keep the remembered "real selected" image in sync with actual selection changes
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.matches) return;
    if (!t.matches('.es-swatch-strip input[type="radio"]')) return;

    const strip = t.closest('.es-swatch-strip');
    if (!strip) return;

    clearHoverRestoreTimer(getStripHoverScope(strip) || strip);
    clearPdpPreviewActive(strip);
    clearHoverPreviewTimer(strip, true);

    // Clear any preview state when a real selection happens
    try { strip.querySelectorAll('.maxus-color.is-preview').forEach((n) => n.classList.remove('is-preview')); } catch(_) {}

    const wrap = t.closest('.maxus-color');
    const label = wrap && wrap.querySelector('label.color_style2');
    const url = extractBgUrl(label);
    if (url) rememberSelectedUrl(strip, upgradeUrl(url, 1200));
  }, true);

  // Prime cache (PDP already has checked by default; Quickview is injected later but this is harmless)
  const primeSelectedCache = (root) => {
    try {
      // Accept an optional collection-card scope so AJAX refreshes only prime
      // visible/near-viewport cards instead of scanning every product at once.
      const scope = root && root.querySelectorAll ? root : document;
      const strips = [];
      if (scope.matches && scope.matches('.es-swatch-strip')) strips.push(scope);
      scope.querySelectorAll('.es-swatch-strip').forEach((strip) => strips.push(strip));
      strips.forEach((strip) => {
        if (!strip.dataset.esSelectedUrl) rememberSelectedFromDom(strip);
      });
    } catch(_) {}
  };
  window.__esPrimeSelectedSwatchCache = primeSelectedCache;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', primeSelectedCache, { once: true });
  } else {
    setTimeout(primeSelectedCache, 0);
  }

  if (canHoverPreview) {
    // PDP + Quickview hover hit-zone guard. Some theme wrappers can stretch the
    // last .maxus-color across blank row space; this geometry check treats only
    // each visible .radio_style2 block as the active hover area.
    let __esPdpPointerMoveRaf = 0;
    let __esLastPdpPointer = null;
    document.addEventListener('mousemove', (e) => {
      if (!__esActivePdpPreviewStrips || !__esActivePdpPreviewStrips.size) return;
      __esLastPdpPointer = { x: e.clientX, y: e.clientY };
      if (__esPdpPointerMoveRaf) return;
      const run = () => {
        __esPdpPointerMoveRaf = 0;
        const p = __esLastPdpPointer;
        if (!p) return;
        Array.from(__esActivePdpPreviewStrips).forEach((strip) => {
          if (!strip || !document.documentElement.contains(strip)) {
            clearPdpPreviewActive(strip);
            return;
          }
          const hot = getPdpSwatchHotItemAtPoint(strip, p.x, p.y);
          if (hot) {
            clearHoverRestoreTimer(strip);
            return;
          }
          scheduleHoverRestore(strip, () => {
            const last = __esLastPdpPointer;
            if (last && getPdpSwatchHotItemAtPoint(strip, last.x, last.y)) return;
            restorePdpStripFromHover(strip);
          }, 35);
        });
      };
      __esPdpPointerMoveRaf = window.requestAnimationFrame ? window.requestAnimationFrame(run) : window.setTimeout(run, 16);
    }, true);

    // Product cards (collection/home/search)
    document.addEventListener('mouseover', (e) => {
      const a = e.target && e.target.closest ? e.target.closest(ES_SWATCH_CONTROL_SELECTOR) : null;
      if (!a) return;
      // Ignore if moving within the same swatch
      if (e.relatedTarget && a.contains(e.relatedTarget)) return;

      const card = findCard(a);
      if (!card) return;

      // underline animation
      const wrap = a.closest('.engoj_select_color');
      if (wrap) {
        const hoverScope = getCollectionHoverScope(wrap) || wrap;
        bindCollectionWrapLeave(wrap);
        clearHoverRestoreTimer(hoverScope);
        wrap.querySelectorAll('.border_thumbnail.is-preview').forEach((n) => n.classList.remove('is-preview'));
        wrap.querySelectorAll('[data-es-swatch-control].is-preview').forEach((n) => n.classList.remove('is-preview'));

        const parentThumb = a.closest('.border_thumbnail');
        const isActive = (parentThumb && parentThumb.classList.contains('is-active')) || a.classList.contains('active');

        if (!isActive) {
          if (parentThumb) parentThumb.classList.add('is-preview');
        }
      }

      const img1 = a.getAttribute('data-engojvariant-img') || a.dataset.engojvariantImg || '';
      const primary = card.querySelector('img.engo-primary-image') || card.querySelector('a.engoj_find_img img');
      const previewUrl = primary ? resolveImageUrl(primary, img1, 1200) : upgradeUrl(img1, 720);
      setCollectionSwatchPreviewState(card, true);
      scheduleHoverPreview(card, (version) => {
        preloadThen(previewUrl, () => {
          if (!isHoverPreviewCurrent(card, version)) return;
          applyCollectionPreviewFromAnchor(card, a);
        });
      }, ES_COLLECTION_HOVER_PREVIEW_DELAY);
    }, true);

    document.addEventListener('mouseout', (e) => {
      const a = e.target && e.target.closest ? e.target.closest(ES_SWATCH_CONTROL_SELECTOR) : null;
      if (!a) return;
      const wrap = a.closest('.engoj_select_color');
      if (!wrap) return;
      const hoverScope = getCollectionHoverScope(wrap) || wrap;

      // Stay on the current preview while moving anywhere inside the broader collection swatch row,
      // including blank gaps between swatches and the small trailing area beside them.
      if (e.relatedTarget && hoverScope.contains(e.relatedTarget)) return;
    }, true);

    // PDP + Quickview (square swatches with label thumbnails)
    // Treat each .maxus-color as the real hover target. Moving to another swatch
    // must switch immediately, even when that next swatch is the currently selected one.
    // Blank row space is no longer considered a valid hover area.
    const getRelatedPdpSwatchItem = (node, strip) => {
      if (!node || !strip || !node.closest) return null;
      const next = node.closest('.es-swatch-strip .maxus-color');
      if (!next) return null;
      return next.closest('.es-swatch-strip') === strip ? next : null;
    };

    document.addEventListener('mouseover', (e) => {
      const item = e.target && e.target.closest ? e.target.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;

      const strip = item.closest('.es-swatch-strip');
      if (!strip) return;

      // Ensure we can always restore to the true selected swatch.
      bindStripLeave(strip);
      clearHoverRestoreTimer(strip);
      clearHoverPreviewTimer(strip, true);
      if (!strip.dataset.esSelectedUrl) rememberSelectedFromDom(strip);

      // Underline animation (preview only; real selection still requires click).
      strip.querySelectorAll('.maxus-color.is-preview').forEach((n) => n.classList.remove('is-preview'));

      const label = item.querySelector('label.color_style2');
      const url = extractBgUrl(label);
      if (!url) return;
      const urlLarge = upgradeUrl(url, 1200);

      const checked = item.querySelector('input[type="radio"]:checked');
      if (checked) {
        // Critical fix: when moving from a non-selected swatch back onto the selected
        // swatch without leaving the strip, immediately restore the selected image.
        clearPdpPreviewActive(strip);
        rememberSelectedUrl(strip, urlLarge);
        setMainImgs(strip, urlLarge);
        return;
      }

      markPdpPreviewActive(strip);
      item.classList.add('is-preview');

      const hoverDelay = item.closest('.quickview-product') ? ES_QUICKVIEW_HOVER_PREVIEW_DELAY : ES_PDP_HOVER_PREVIEW_DELAY;

      scheduleHoverPreview(strip, (version) => {
        preloadThen(resolveMainPreviewUrl(strip, urlLarge), () => {
          if (!isHoverPreviewCurrent(strip, version)) return;
          setMainImgs(strip, urlLarge);
        });
      }, hoverDelay);
    }, true);

    document.addEventListener('mouseout', (e) => {
      const item = e.target && e.target.closest ? e.target.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;
      const strip = item.closest('.es-swatch-strip');
      if (!strip) return;

      // If moving inside the same swatch item, ignore.
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;

      // If moving directly into another swatch item in the same strip, let that swatch's
      // mouseover handler take over immediately. Do not use the whole row as hover state.
      if (getRelatedPdpSwatchItem(e.relatedTarget, strip)) return;

      // Leaving the actual swatch square/text area into blank row space counts as leaving
      // swatches. Use a short grace so fast movement across tiny gaps does not flicker.
      const restoreDelay = item.closest('.quickview-product') ? ES_QUICKVIEW_RESTORE_GRACE : ES_PDP_RESTORE_GRACE;
      scheduleHoverRestore(strip, () => {
        const last = __esLastPdpPointer;
        if (last && getPdpSwatchHotItemAtPoint(strip, last.x, last.y)) return;
        restorePdpStripFromHover(strip);
      }, restoreDelay);
    }, true);
  }


  /* =========================================================
     ES FIX: iPad/Tablet PDP swatch reliability
     - iPad uses the mobile header (Bootstrap < xl) and touch input
     - Make the whole swatch item clickable (including the text)
     - Ensure main image updates on selection even without hover
  ========================================================= */
  document.addEventListener('click', function(e){
    try{
      var item = e.target && e.target.closest ? e.target.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;
      var input = item.querySelector('input[type="radio"]');
      if (!input) return;

      // If user taps the color name (not the label), force-select the radio.
      if (!input.checked && e.target.tagName !== 'LABEL') {
        input.click();
      }
    }catch(_){}
  }, true);

  document.addEventListener('change', function(e){
    try{
      var input = e.target;
      if (!input || input.type !== 'radio') return;
      var item = input.closest ? input.closest('.es-swatch-strip .maxus-color') : null;
      if (!item) return;

      // Use the swatch label bg image as a fallback to update the PDP main image.
      var label = item.querySelector('label.color_style2') || item.querySelector('label');
      if (!label) return;
      var url = extractBgUrl(label);
      if (!url) return;

      var strip = item.closest ? item.closest('.es-swatch-strip') : null;
      if (!strip) return;

      clearHoverRestoreTimer(getStripHoverScope(strip) || strip);
      rememberSelectedUrl(strip, url);
      setMainImgs(strip, url);
    }catch(_){}
  }, true);



  /* ==========================================================
     ES: Swatch horizontal scroll hint (PDP + any swatch strip)
     - Adds classes to show subtle edge fades only when overflow
     ========================================================== */
  var esScrollHintStrips = new Set();
  var esScrollHintRafMap = new WeakMap();
  var esScrollHintResizeBound = false;

  function esUpdateSwatchScrollHint(strip){
    try{
      if (!strip || !document.documentElement.contains(strip)) return;
      var overflow = (strip.scrollWidth - strip.clientWidth) > 2;
      var atStart = strip.scrollLeft <= 1;
      var atEnd = (strip.scrollLeft + strip.clientWidth) >= (strip.scrollWidth - 1);
      var scrolled = strip.scrollLeft > 1;

      strip.classList.toggle('es-overflow', overflow);
      strip.classList.toggle('es-at-start', atStart);
      strip.classList.toggle('es-at-end', atEnd);
      strip.classList.toggle('es-scrolled', scrolled);

      if (!overflow) strip.classList.remove('es-scrolled','es-at-start','es-at-end');
    }catch(_){}
  }

  function esScheduleSwatchScrollHint(strip){
    if (esScrollHintRafMap.get(strip)) return;
    esScrollHintRafMap.set(strip, true);
    requestAnimationFrame(function(){
      esScrollHintRafMap.delete(strip);
      esUpdateSwatchScrollHint(strip);
    });
  }

  function esPruneSwatchScrollHintStrips(){
    esScrollHintStrips.forEach(function(strip){
      if (!strip || !document.documentElement.contains(strip)) esScrollHintStrips.delete(strip);
    });
  }

  function esInitSwatchScrollHints(root){
    esPruneSwatchScrollHintStrips();
    var scope = root && root.querySelectorAll ? root : document;
    var strips = [];
    if (scope.matches && scope.matches('.es-swatch-strip')) strips.push(scope);
    scope.querySelectorAll('.es-swatch-strip').forEach(function(strip){ strips.push(strip); });
    if (!strips.length) return;

    strips.forEach(function(strip){
      if (!strip) return;
      esScrollHintStrips.add(strip);
      if (strip.getAttribute('data-es-scrollhint') === '1') {
        esUpdateSwatchScrollHint(strip);
        return;
      }
      strip.setAttribute('data-es-scrollhint','1');
      esUpdateSwatchScrollHint(strip);
      strip.addEventListener('scroll', function(){ esScheduleSwatchScrollHint(strip); }, {passive:true});
      if (document.readyState !== 'complete') {
        window.addEventListener('load', function(){ esUpdateSwatchScrollHint(strip); }, {once:true});
      }
    });

    if (!esScrollHintResizeBound) {
      esScrollHintResizeBound = true;
      var resizeTimer = null;
      window.addEventListener('resize', function(){
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function(){
          esScrollHintStrips.forEach(function(strip){
            if (!strip || !document.documentElement.contains(strip)) {
              esScrollHintStrips.delete(strip);
              return;
            }
            esUpdateSwatchScrollHint(strip);
          });
        }, 120);
      }, {passive:true});
    }
  }
  window.__esInitSwatchScrollHints = esInitSwatchScrollHints;

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', esInitSwatchScrollHints);
  }else{
    esInitSwatchScrollHints();
  }


})();

/* ES PDP selected-color note
   Reads variant metafield custom.color_note rendered by snippets/swatch.liquid.
   Only the note for the currently selected color swatch is shown. */
(function(){
  if (window.__esSelectedColorNoteInit) return;
  window.__esSelectedColorNoteInit = true;

  function syncColorNote(swatch){
    if (!swatch || !swatch.querySelector) return;
    if (!swatch.classList || !swatch.classList.contains('es-swatch--color')) return;

    var container = swatch.querySelector('[data-es-color-notes]');
    if (!container) return;

    var checked = swatch.querySelector('input[type="radio"]:checked');
    var value = checked ? checked.value : '';
    var notes = container.querySelectorAll('[data-es-color-note-value]');
    var hasActive = false;

    notes.forEach(function(note){
      var active = !!value && note.getAttribute('data-es-color-note-value') === value;
      note.classList.toggle('is-active', active);
      if (active) {
        note.removeAttribute('hidden');
        hasActive = true;
      } else {
        note.setAttribute('hidden', 'hidden');
      }
    });

    container.style.display = hasActive ? '' : 'none';
  }

  function syncAllColorNotes(root){
    (root || document).querySelectorAll('.swatch.es-swatch--color[data-option-index]').forEach(syncColorNote);
  }

  function queueSyncFromTarget(target){
    var swatch = target && target.closest ? target.closest('.swatch.es-swatch--color[data-option-index]') : null;
    if (!swatch) return;
    window.setTimeout(function(){ syncColorNote(swatch); }, 0);
    window.setTimeout(function(){ syncColorNote(swatch); }, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ syncAllColorNotes(document); });
  } else {
    syncAllColorNotes(document);
  }

  document.addEventListener('change', function(e){
    if (e.target && e.target.matches && e.target.matches('.swatch.es-swatch--color input[type="radio"]')) {
      queueSyncFromTarget(e.target);
    }
  });

  document.addEventListener('click', function(e){
    var target = e.target && e.target.closest ? e.target.closest('.swatch.es-swatch--color input[type="radio"], .swatch.es-swatch--color label, .swatch.es-swatch--color [data-value]') : null;
    if (target) queueSyncFromTarget(target);
  }, true);

  window.addEventListener('load', function(){ syncAllColorNotes(document); });
})();
